export const LOCAL_STORAGE_KEYS = {
    CURRENT_USER_KEY: 'user',
    TENANT_ID: 'tenantId',
    VTRACKER_SELECTED_INCIDENT: 'vtrackerIncident',
    VADMIN_SELECTED_INCIDENT: 'vadminIncident',
    UNIT_ID: 'unitId',
    DEPARTMENT: 'department',
    COOKIE_CONSENT: 'cookieConsent',
} as const;
